import styled, { css } from "styled-components";
import { IStyleProps } from "./interfaces";

export const AttentionMarker = styled.div<IStyleProps>`
    position: absolute;
    background-color: ${p => p.theme.c.info};
    right: calc(100% + ${p => (p.isBrowse ? -40 : 8)}px);
    top: ${p => (p.isBrowse ? 42 : 0)}px;
    white-space: nowrap;
    padding: 6px 10px 6px 8px;
    border-radius: 5px;
    color: ${p => p.theme.c.white};
    text-shadow: 0 0 2px ${p => p.theme.c.blackShadow3};
    box-shadow: 0 0 2px 0 ${p => p.theme.c.blackShadow3};
    pointer-events: none;
    ${p =>
        p.theme.xs(css`
            right: auto;
            left: ${p.isBrowse ? -50 : 0}px;
            top: -42px;
        `)}
`;

export const AttentionArrow = styled.div<IStyleProps>`
    width: 12px;
    height: 12px;
    background-color: ${p => p.theme.c.info};
    position: absolute;
    right: ${p => (p.isBrowse ? 16 : -5)}px;
    top: ${p => (p.isBrowse ? -5 : 10)}px;
    border-radius: 2px;
    transform: rotate(45deg);
    ${p =>
        p.theme.xs(css`
            right: auto;
            left: ${p.isBrowse ? 61 : 10}px;
            top: 26px;
        `)}
`;
